module.exports = __webpack_public_path__ + "static/media/icon-plus-black.9b45947f.svg";